import {getArtefactTripletFromUrn, getStringFromArtefactTriplet} from "../../../../utils/sdmxJson";
import {wrapColumnWithDBSpecificParenthesis} from "../../dataset-builder/modals/components/utils";

export const prepareMappingSetForSaving = (name, description, selectedMappingSet, selectedDataset, dataflow, mappings) => {
    return {
        EntityId: selectedMappingSet ? selectedMappingSet.entityId : "",
        Name: name,
        Description: description,
        DatasetId: selectedDataset.id,
        IdMappings: [],
        Mappings: (mappings || []).map(mapping => {
            let tempArray = [];
            !Array.isArray(mapping.columnObj)? tempArray.push(mapping.columnObj) : tempArray = [...mapping.columnObj] 
            const datasetCols = (tempArray || []).filter(obj => !!obj && Object.keys(obj).length > 0);
            return {
                entityId: mapping.entityId || 0,
                parentId: selectedMappingSet ? selectedMappingSet.entityId : "",
                dataset_column: datasetCols.length ? datasetCols : null,
                constantValue: mapping.constantValue || null,
                component: {id: mapping.dsdColumnName},
                transcoding: mapping.transcoding || null,
                type: mapping.type || null,
            }
        }),
        DataflowId: dataflow.id,
        Agency: dataflow.agencyID,
        Version1: dataflow.version.split('.')[0],
        Version2: dataflow.version.split('.')[1]
    }
}

export const prepareMappingSetObject = (data) => {
    const newData = {...data};
    newData.version = `${newData.version1}.${newData.version2}`
    return newData;
}

export const prepareMappingsForTable = (mappings, dsd) => {
    return (mappings || []).map(mapp => ({
        ...mapp,
        columnObject: mapp.dataset_column,
        constantValue: mapp.constantValue,
        dsdColumnName: mapp.component.id,
        columnName: mapp.dataset_column.map(item => item.name),
        dsdCodelist: dsd.filter(e => e.id === mapp.component.id).map(e => !!e && !!e.localRepresentation &&
        !!e.localRepresentation.enumeration ? getArtefactTripletFromUrn(e.localRepresentation.enumeration) : null).reduce(e => e),
        dsdType: dsd.filter(e => e.id === mapp.component.id).map(e => !!e.type ? e.type : null).reduce(e => e)
    }))
}

export const makeQueryDistinctForColumn = (query, colName, dbType) => {
    if (colName) {
        if (!query.includes("*")) {
            if (!query.toLowerCase().includes("from")) {
                return query.replace(/select/ig, 'SELECT DISTINCT')
            }
            return `SELECT DISTINCT ${wrapColumnWithDBSpecificParenthesis(colName, dbType)} FROM ${query.toLowerCase().split("from")[1]}`
        }
        return query.replace(/select/ig, 'SELECT DISTINCT').replaceAll("*", wrapColumnWithDBSpecificParenthesis(colName, dbType));
    }
    return query.replace(/select/ig, 'SELECT DISTINCT');
}

export const componentHasCodelist = (attribute) => !!attribute.localRepresentation &&
    !!attribute.localRepresentation.enumeration &&
    !!getStringFromArtefactTriplet(getArtefactTripletFromUrn(attribute.localRepresentation.enumeration))

export const addStatusToStash = (stash, t) => {
    if (!stash) return [];
    return stash.map(item => {
        if (item.constantValue) {
            return {
                ...item,
                status: `${t("scenes.mappingHandler.MappingSet.wizard.steps.second.table.constantTranscoding")}: ${item.constantValue}`
            }
        }
        if((!item.dsdCodelist && item.hasOwnProperty("dsdCodelist")) && item.dsdType !== 'TimeDimension' && !item.constantValue) {
            return {
                ...item,
                status: t("scenes.mappingHandler.MappingSet.wizard.steps.second.table.transcodingNotNeeded")
            }
        }
        return {
            ...item,
            status: item.transcoding || item.timeTranscoding ? t("scenes.mappingHandler.MappingSet.wizard.steps.second.table.transcodingPresent") : t("scenes.mappingHandler.MappingSet.wizard.steps.second.table.transcodingAbsent")
        }
    });
}

export const checkSaveAndOpenModal = (needsToBeSaved, openSaveModal, openModal, setSaveModalCallback) => {
    if (needsToBeSaved) {
        openSaveModal(true);
        setSaveModalCallback(() => openModal)
        return;
    }
    openModal();
}

export const getCurrentTranscoding = (transcodingObj, stash) => {
    if (!transcodingObj.entityId) {
        const transcodingFromStash = stash.find(item => item.dsdColumnName === transcodingObj.dsdColumnName);
        return transcodingFromStash || transcodingObj;
    }
    const transcodingFromStash = stash.find(item => item.entityId === transcodingObj.entityId && item.dsdType === transcodingObj.dsdType);
    return transcodingFromStash || transcodingObj;
}

export const isDSDMandatory = (component) => {
    if(component.assignmentStatus && component.assignmentStatus === "Conditional"){
        return false;
    }
    return true;
}

export const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}